import { FileQuestion, ShieldOff } from "lucide-react";
import { Link } from "react-router-dom";
import { EmptyState } from "@/components/app/EmptyState";
import { Button } from "@/components/ui/button";
import { HOME } from "@/lib/routes";

export function NotFoundPage() {
  return (
    <EmptyState
      icon={FileQuestion}
      title="That page does not exist"
      action={
        <Button asChild>
          <Link to={HOME}>Go to Needs me</Link>
        </Button>
      }
    >
      The link may be old or mistyped.
    </EmptyState>
  );
}

export function ForbiddenPage({ needs = "a Reviewer/Admin" }: { needs?: string }) {
  return (
    <EmptyState
      icon={ShieldOff}
      title="You do not have permission to see this"
      action={
        <Button asChild variant="outline">
          <Link to={HOME}>Back to Needs me</Link>
        </Button>
      }
    >
      This screen is for {needs}. If you think you should have access, ask a Reviewer/Admin.
    </EmptyState>
  );
}
